import { useStore } from "@/store";
import { observer } from "mobx-react-lite";
import { FunctionComponent, useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const SignOut: FunctionComponent = observer((): null => {
  const store = useStore();
  const navigate = useNavigate();

  const doLogout = useCallback(async (): Promise<void> => {
    await store.auth.signOut();
    await store.parameters.clear();

    navigate("/login", { replace: true });
  }, []);

  useEffect((): void => {
    doLogout();
  }, []);

  return null;
});
